import React from 'react';
import { Input } from 'reactstrap';
import { PropTypes } from 'prop-types';

const ORDER = 'order';
const ASC = 'ascending';
const DESC = 'descending';

const SortOrder = ({ onDataChange, order }) => {
  const ascSelected = order === ASC;
  const descSelected = order === DESC;

  return (
    <div className="row config-container align-items-center">
      <div className="config-title mr-3">
        Sort Order
      </div>
      <Input className="input-width" type="select" name="select" onChange={(e) => { onDataChange(ORDER, e.target.value.toLowerCase()); }}>
        <option selected={descSelected}>Descending</option>
        <option selected={ascSelected}>Ascending</option>
      </Input>
    </div>
  );
};

SortOrder.propTypes = {
  onDataChange: PropTypes.func,
  order: PropTypes.string
};

SortOrder.defaultProps = {
  onDataChange: () => { },
  order: ''
};

export default SortOrder;



// WEBPACK FOOTER //
// ./src/components/dashboard/list/configuration-elements/SortOrder.js